<style>
.ivu-table .demo-table-settled-row td {
    color: #19be6b;
}

.ivu-table .demo-table-disc-row td {
    color: #c30e0e;
}

.ivu-table .demo-table-claim-row td {
    color: #2db7f5;
}

.ivu-table .demo-table-claim-depo-row td {
    color: #c32df5;
}

.ivu-table .demo-table-giro-row td {
    color: #de2df5;
}
</style>

<template>
    <div>

        <Card>
            <p slot="title">
                Kartu Piutang History
            </p>
            <Row type="flex" justify="space-between" class="code-row-bg">
                <Col span="6">
                <Select style="width: 250px;" placeholder="Ketik Marking" v-model="markingIdSelected" filterable
                    clearable remote :remote-method="getMarkingByCode" :loading="loadingGetMarking"
                    @on-change="setMarkingCode()">
                    <Option v-for="option in optionMarkings" :value="option.value" :key="option.value">{{ option.label
                    }}
                    </Option>
                </Select>

                </Col>
                <Col span="6">
                <Spin size="large" v-show="loadingGetReceivable"></Spin>
                </Col>
                <Col span="6">
                </Col>
            </Row>

            <br>

            <Card v-show="(receivables.length > 0 || isSupervisor()) && markingIdSelected">
                <p slot="title">
                </p>
                <template slot="extra">
                    <Button v-show="canCreateReceivable()" type="success" @click="modal.createReceivable = true"
                        icon="plus-round" size="small">
                        Tambah Piutang
                    </Button>
                </template>
                <div v-show="topColor">
                  <Alert :type="topColor === 'GREEN' ? 'success' : topColor === 'YELLOW' ? 'warning' : topColor === 'RED' ? 'error' : 'info'" show-icon>
                    Term Of Payment
                  </Alert>
                </div>
                <div v-show="depositRemaining > 0">
                    <Alert type="warning" show-icon>Deposit = {{ depositRemaining | currency }}</Alert>
                    <Alert show-icon>Balance - Deposit = {{ (countBalance - depositRemaining) | currency }}</Alert>
                </div>

                <div v-show="depositMutasiRemaining > 0">
                    <Alert type="warning" show-icon>Deposit Mutasi = {{ depositMutasiRemaining | currency }}</Alert>
                    <!-- <Alert show-icon>Balance - Deposit Mutasi = {{ (countBalance - depositMutasiRemaining) | currency }}</Alert> -->
                </div>

                <Table :row-class-name="rowClassName" :columns="tableColumns" :data="receivables" no-data-text="">
                </Table>
            </Card>
        </Card>

        <Modal v-model="modal.createReceivable" width="500px" @on-cancel="clearCreateReceivable()">
            <p slot="header" style="color:#2d8cf0;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Tambah Piutang</span>
            </p>

            <Form :label-width="120">
                <Form-item label="Tgl Transaksi">
                    <Row>
                        <Col span="4">
                        <Date-picker v-model="createReceivable.transactionDate" style="width: 110px;" type="date"
                            placeholder="" format="dd/MM/yyyy">
                        </Date-picker>

                        </Col>
                        <Col span="1">&nbsp;
                        </Col>
                    </Row>
                </Form-item>
                <Form-item label="Keterangan" v-show="true">
                    <Input v-model="createReceivable.description" style="width: 300px;"></Input>
                </Form-item>
                <Form-item label="Jumlah" v-show="true">
                    <money v-model="createReceivable.amount" v-bind="money" class="ivu-input right"
                        style="width: 150px;">
                    </money>
                </Form-item>
                <Form-item label="Upload File" prop="file">
                    <br>
                    <Upload type="drag" ref="upload" name="fileUploaded" :action="this.serverUrlUploadFile"
                        :before-upload="handleBeforeUpload">
                        <div style="padding: 20px 0">
                            <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                            <p>Click or drag files here to upload</p>
                        </div>
                    </Upload>
                    <Progress :percent="pValue" :stroke-width="20" v-show="isProgress" />
                </Form-item>
            </Form>

            <div slot="footer">
                <Button v-show="true" type="primary" :loading="loadingCreateReceivable" @click="postCreateReceivable">
                    <span v-if="!loadingCreateReceivable">Simpan</span>
                    <span v-else>Wait.....</span>
                </Button>
            </div>
        </Modal>

        <Modal v-model="modal.createPayment" width="80%">
            <p slot="header" style="color:#2d8cf0;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Payment set</span>
            </p>

            <Form :label-width="120">

                <Form-item label="Tgl Pembayaran">
                    <Row>
                        <Col span="5">
                        <Date-picker v-model="createPaymentPending.paymentDate" style="width: 250px;" type="date"
                            format="yyyy-MM-dd" @on-change="checkButtonSave">
                        </Date-picker>
                        </Col>
                    </Row>
                </Form-item>

                <Form-item label="Marking">
                    <Input v-model="createPaymentPending.selectedMarkingLabel" disabled style="width: 250px;"
                        placeholder="Marking"></Input>
                </Form-item>

                <Form-item label="Keterangan">
                    <Input v-model="createPaymentPending.description" style="width: 250px;"
                        @on-change="checkButtonSave"></Input>
                </Form-item>

                <Form-item label="Deposito Mutasi">
                    <Alert style="width: 250px;" type="warning" show-icon>{{
                        createPaymentPending.mutasiRemainingPayment | currency }}
                    </Alert>
                    <font style="color: red;"
                        v-if="createPaymentPending.totalUseDepositAmount > 0 && createPaymentPending.totalUseDepositAmount > createPaymentPending.mutasiRemainingPayment">
                        Terpakai
                        {{ createPaymentPending.totalUseDepositAmount | currency }} - LEBIH</font>

                    <font style="color: green;"
                        v-if="createPaymentPending.totalUseDepositAmount > 0 && createPaymentPending.totalUseDepositAmount <= createPaymentPending.depositRemainingPayment">
                        Terpakai: {{ createPaymentPending.totalUseDepositAmount | currency }}, Sisa: {{
                            (createPaymentPending.depositRemainingPayment -
                                createPaymentPending.totalUseDepositAmount) | currency }}
                    </font>
                </Form-item>

                <Form-item label="Uang Diterima">
                    <money v-model="createPaymentPending.amountReceived" v-bind="money" class="ivu-input right"
                        style="width: 250px;" disabled>
                    </money>

                    <font v-show="createPaymentPending.amountResidue != 0" style="margin-left: 20px;">
                        Selisih &nbsp; {{ createPaymentPending.amountResidue | currency }}
                    </font>
                </Form-item>

            </Form>

            <Card v-show="this.invoiceDues.length > 0">
                <p slot="title">
                    Daftar Invoice
                </p>

                <Row type="flex" class="code-row-bg ivu-row-flex-space-between">
                    <template>
                        <Col span="2">
                        Tgl Bongkar
                        </Col>
                        <Col span="8">
                        Keterangan
                        </Col>
                        <Col span="2">
                        Total
                        </Col>
                        <Col span="1">
                        </Col>
                        <Col span="2">
                        Sisa
                        </Col>
                        <Col span="1">
                        </Col>
                        <Col span="5">
                        Alokasi Pembayaran
                        </Col>
                        <Col span="1">
                        </Col>
                    </template>
                </Row>
                <br />
                <hr />
                <br />
                <div v-for="invoiceDue in invoiceDues">
                    <cInvoicePaymentMutasi :invoiceDue="invoiceDue"
                        :depositRemaining="createPaymentPending.depositRemainingPayment"
                        :paymentPendingId="createPaymentPending.paymentPendingId"
                        :paymentPendingAmount="createPaymentPending.paymentPendingAmount"
                        @setAllocateAmount="setAllocateAmount">
                    </cInvoicePaymentMutasi>
                    <br />
                </div>
            </Card>

            <div slot="footer">
                <Button v-show="isButtonSave" type="primary" :loading="loadingCreateReceivable" @click="postPayment">
                    <span v-if="!loadingCreateReceivable">Simpan</span>
                    <span v-else>Wait.....</span>
                </Button>
            </div>
        </Modal>

    </div>
</template>

<script>
import { HTTP } from '@/components/http-lib'
import cInvoicePaymentMutasi from '@/components/receivable/cInvoicePaymentMutasi'
import _ from 'lodash'
import moment from 'moment'
import { Money } from 'v-money'

const numeral = require('numeral');
var axios = require('axios');

export default {
    components: { cInvoicePaymentMutasi, Money },
    data() {
        return {
            user: {
                username: '',
                role: ''
            },
            money: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 0,
                masked: false
            },
            modal: {
                createReceivable: false,
                createPayment: false
            },
            createReceivable: {
                transactionDate: '',
                description: '',
                amount: 0,
                filename: ''
            },
            createPaymentPending: {
                paymentDate: '',
                mutasiRemainingPayment: 0, // mutasi deposit sebelumnya
                depositRemainingPayment: 0,
                amountReceived: '',
                amountResidue: '',
                description: '',
                paymentPendingAmount: 0,
                totalUseDepositAmount: 0,
                paymentPendingId: null,
                category: '',
                selectedMarkingLabel: '',
                creditRound: 0,
                receivableId: '',
                depositType: '',
                accountNumber: '',
                discountReceived: '',
            },
            totalMutasiRemaining: 0, // untuk total deposit di modal payment set
            loadingCreateReceivable: false,
            markingIdSelected: '',
            markingLabelSelected: '',
            topColor: null,
            depositRemaining: Number, // untuk menampung total sisa deposit
            depositMutasiRemaining: Number, // untuk menampung total sisa deposit
            countBalance: Number,
            totalKredit: Number,
            totalDebet: Number,
            totalBalance: Number,
            optionMarkings: [],
            loadingGetMarking: false,
            loadingGetReceivable: false,
            markings: [],
            receivables: [],
            subbranchcode: localStorage.getItem('user.subbranchcode'),
            tableColumns: [
                {
                    type: 'index',
                    width: 80,
                    align: 'center'
                },
                {
                    title: 'Tgl',
                    key: 'transactionDate',
                    type: 'html',
                    sortable: false
                },
                {
                    title: 'Keterangan',
                    key: 'description',
                    width: 300,
                    type: 'html',
                    sortable: false
                },
                {
                    title: 'Debet',
                    key: 'debitAmount',
                    align: 'right',
                    sortable: false,
                    cellClassName: {
                        name: 'demo-table-info-cell-name'
                    }

                },
                {
                    title: 'Kredit',
                    key: 'creditAmount',
                    align: 'right',
                    sortable: false,
                    render: (h, params) => {
                        let creditAmount = params.row.creditAmount.replace(/,/g, '')
                        let receivableAvailable = parseInt(creditAmount) - parseInt(params.row.paymentSum)
                        if (params.row.type == 'DFM' && receivableAvailable > 0 && params.row.payment === null) {
                            console.info(receivableAvailable, creditAmount, params.row.paymentSum)
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small'
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.handleKreditClick(params.row)
                                        }
                                    }
                                }, params.row.creditAmount)
                            ]);
                        } else {
                            return h('span', {
                                props: {},
                                style: {}
                            }, params.row.creditAmount);
                        }
                    }
                },
                {
                    title: 'Balance',
                    key: 'balance',
                    align: 'right',
                    sortable: false
                }
            ],
            filterInput: '',
            serverUrlUploadFile: '',
            isProgress: false,
            pValue: 0,
            invoiceDues: [],
            loadingGetPayment: false,
            isButtonSave: false,
        }
    },
    methods: {
        clearCreateReceivable() {
            this.createReceivable.transactionDate = ''
            this.createReceivable.description = ''
            this.createReceivable.amount = 0
            this.createReceivable.filename = ''
        },
        canCreateReceivable() {
            let canAccess = _.includes(['SUPERVISOR', 'ADMINISTRATOR', 'ADMIN', 'ADMIN-DEPOSIT', 'SUPERVISOR-SBY'], this.user.role);
            console.log('this.user.role = ' + this.user.role)
            console.log('canAccess = ' + canAccess)
            return canAccess;
        },
        isSupervisor() {
            let isSupervisor = ["WILYA-FA", "SURYANTI", "SUSAN", "INDRA", "SURINDA", "LINDA", "ADRI", "ERIC", "SYSTEM"].includes(this.user.username);

            return isSupervisor;
        },
        handleBeforeUpload(file) {
            console.log({ file });

            const formData = new FormData();
            formData.append('file', file);
            formData.append('marking', this.markingLabelSelected);

            this.isProgress = true;
            this.pValue = Math.floor(Math.random() * 100); // Returns a random integer from 0 to 99:

            HTTP
                .post('receivable/file/upload', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                .then(response => {
                    this.createReceivable.filename = response.data.filename; // Set filename
                    // this.isProgress = false;
                    this.pValue = 100;
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })

            return false; // Kembalikan false untuk mencegah unggahan otomatis
        },
        postCreateReceivable() {
            this.loadingCreateReceivable = true
            this.createReceivable.transactionDate = moment(this.createReceivable.transactionDate, 'YYYY-MM-DD').format("YYYY-MM-DD");

            let payload = {
                markingHeaderId: this.markingIdSelected,
                transactionDate: this.createReceivable.transactionDate,
                description: this.createReceivable.description,
                amount: this.createReceivable.amount,
                filename: this.createReceivable.filename,
            }

            console.log({ payload });
            HTTP
                .post('receivable/debit/create', payload)
                .then(response => {
                    this.clearCreateReceivable()

                    this.loadingCreateReceivable = false
                    this.modal.createReceivable = false
                    this.getReceivableData()
                })
                .catch(e => {
                    this.clearCreateReceivable()
                    this.loadingCreateReceivable = false
                    this.modal.createReceivable = false
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        rowClassName(row, index) {

            if (row.isSettled) {
                return 'demo-table-settled-row';
            }

            if (row.category == 'disc') {
                return 'demo-table-disc-row';
            }

            if (row.claimId) {
                return 'demo-table-claim-depo-row';
            }

            if (row.claim) {
                return 'demo-table-claim-row';
            }

            if (row.giroId) {
                return 'demo-table-giro-row';
            }

            return '';
        },
        getReceivable: function () {
            if (this.markingIdSelected !== '') {
                return HTTP.get('receivable/show/' + this.markingIdSelected)
            } else {
                this.receivables = []
            }
        },
        getDepositRemaining: function () {
            if (this.markingIdSelected !== '') {
                return HTTP.get('deposit/remaining/' + this.markingIdSelected)
            } else {
                this.depositRemaining = 0;
            }
        },
        getDepositMutasiRemaining: function () {
            if (this.markingIdSelected !== '') {
                return HTTP.get('deposit/mutasi/' + this.markingIdSelected)
            } else {
                this.depositMutasiRemaining = 0;
            }
        },
        getReceivableData: function () {
            let parent = this;

            this.invoiceDues = []
            this.receivables = []
            this.amountResidue = ''
            this.amountReceived = ''
            this.description = ''
            this.depositRemaining = Number
            this.depositMutasiRemaining = Number
            this.countBalance = Number
            this.totalMutasiRemaining = 0


            if (this.markingIdSelected == '') {
                return;
            }

            this.loadingGetReceivable = true;
            axios.all([
                this.getReceivable(),
                this.getDepositRemaining(),
                this.getDepositMutasiRemaining(),
            ]).then(axios.spread((receivableRes, depositRemainingRes, depositMutasiRes) => {
                let receivables = []
                let countBalance = 0;
                let totalKredit = 0;
                let totalDebet = 0;
                let totalBalance = 0;

                _.forEach(receivableRes.data, function (value) {
                    let invoicefee = value.invoice != null ? value.invoice.invoicefee : 0;
                    let creditAmount = value.creditAmount
                    let debitAmount = value.debitAmount;
                    let paymentSum = value.payment_sum;

                    let totalvolume = value.invoice != null ? value.invoice.totalvolume : 0;
                    let isSettled = parent.isSettled(value.invoice_due)

                    let description = value.description
                    if (value.invoice != null) {
                        description += "<br/>( vol = " + numeral(totalvolume).format('0.000');

                        if (invoicefee != debitAmount) {
                            description += ", inv = " + numeral(invoicefee).format('0,0')
                        }
                        description += " )"
                    }

                    totalKredit += value.creditAmount
                    totalDebet += value.debitAmount
                    totalBalance += value.balance

                    //Faisal 12 Januari : Deposit dari Klaim tidak mempengaruhi perhitungan balance
                    // if ((value.type == 'DEP' && value.claimId != null && value.type != 'DFM') || value.isCalculated == 0 || description.includes('Penarikan')) {

                    // } else {
                    //     let subBalance = (debitAmount - value.creditAmount)
                    //     countBalance = (countBalance + subBalance)
                    // }

                    let arrayDescriptionContainer = '';
                    let arrayClaimDetail = '';
                    let arrayClaimGroupDetail = [];
                    let isCategory = ''; // pay or disc

                    if (value.payment != null) {
                        if (value.payment.payment_allocate != null) {
                            arrayDescriptionContainer = value.payment.payment_allocate
                        }

                        if (value.payment.claim != null) {
                            arrayClaimDetail = value.payment.claim.claim_detail
                        }

                        if (value.payment.claim != null) {
                            arrayClaimDetail = value.payment.claim.claim_detail

                            if (value.payment.claim_group != null) {
                                arrayClaimGroupDetail = value.payment.claim_group.claim_group_detail
                            }
                        }

                        isCategory = value.payment.category
                    }

                    if (isCategory == 'disc') {
                        _.forEach(arrayClaimDetail, function (claim) {
                            description += '<br/> - ' + claim.description
                        })

                        _.forEach(arrayClaimGroupDetail, function (claim) {
                            description += '<br/> - ' + claim.description
                        })
                    } else {
                        _.forEach(arrayDescriptionContainer, function (paymentAllocate) {
                            if (paymentAllocate.invoice_due != null) {
                                description += '<br/>- ' + paymentAllocate.invoice_due.receivable.description
                            } else {
                                description += '<br/><font style="color:red">- NOT_FOUND </font>'

                                var errorMessage = 'Transaksi tgl ' + parent.showDateFormatted(value.transactionDate) + ' ada Invoice yang berubah';

                                parent.$Notice.warning({
                                    title: "Perhatian",
                                    desc: errorMessage,
                                    duration: 0
                                });

                            }
                        })
                    }

                    let category = ''
                    let claim = ''
                    let giro = ''
                    let giroId = ''
                    let claim_group = ''

                    if (value.payment) {
                        category = value.payment.category
                        claim = value.payment.claim
                        giro = value.payment.giro
                        giroId = value.payment.giroId

                        if (value.payment.claim) {
                            if (value.payment.claim.list_claim_group) {
                                claim_group = value.payment.claim.list_claim_group.claim_group_detail
                                // console.info(claim, claim_group) // ini harus didetailkan lagi karena ada claim dan claim_group nya
                            }
                        }
                    }

                    const compareDate = new Date("2025-03-01")
                    let markingHeader = value.marking_header.markingheadercode.split('/')[0]
                    let isPrefixSPecial = markingHeader == "SBR" || markingHeader == "SBRT" || markingHeader == "CTH"
                    let creditAmountIdr = creditAmount
                    let debitAmountIdr = debitAmount
                    let currencyRate = null;
                    let debitResult = 0;
                    let creditResult = 0;
                    let transactionDate = new Date(value.transactionDate)

                    if (value.payment != null && value.payment.amount > 0 && isPrefixSPecial) { // Jika ada payment (kredit)
                        debitAmount = 0;
                        // creditAmount = 0
                        debitAmountIdr = 0;
                        creditAmountIdr = 0;

                        value.payment.payment_allocate.forEach(paymentAllocate => {
                            let receivableId = paymentAllocate.invoice_due.receivable.id;
                            const receivable = receivableRes.data.find(receiObj => receiObj.id == receivableId);
                            debitAmount = debitAmount + parseFloat(0);
                            // creditAmount = creditAmount + parseFloat(paymentAllocate.allocateAmount);
                            if (receivable && receivable.invoice && receivable.invoice.packaging_list.container_loading.currency_sgd && transactionDate < compareDate) {
                              if(value.isConvert == 2 || transactionDate >= compareDate) {
                                currencyRate = value.currency_sgd.currencyrate;
                                debitAmountIdr = debitAmountIdr + (parseFloat(0) * currencyRate);
                                creditAmountIdr = creditAmountIdr + (parseFloat(paymentAllocate.allocateAmount) * currencyRate);
                              } else {
                                currencyRate = receivable.invoice.packaging_list.container_loading.currency_sgd.currencyrate;
                                debitAmountIdr = debitAmountIdr + (parseFloat(0) * currencyRate);
                                creditAmountIdr = creditAmountIdr + (parseFloat(paymentAllocate.allocateAmount) * currencyRate);
                              }

                            } else if (value && value.currency_sgd) {
                              if(value.isConvert == 2 || receivable.invoice == null || transactionDate >= compareDate) {
                                currencyRate = value.currency_sgd.currencyrate;
                                debitAmountIdr = debitAmountIdr + (parseFloat(0) * currencyRate);
                                creditAmountIdr = creditAmountIdr + (parseFloat(paymentAllocate.allocateAmount) * currencyRate);
                              } else {
                                currencyRate = receivable.invoice.packaging_list.container_loading.currency_sgd.currencyrate;
                                debitAmountIdr = debitAmountIdr + (parseFloat(0) * currencyRate);
                                creditAmountIdr = creditAmountIdr + (parseFloat(paymentAllocate.allocateAmount) * currencyRate);
                              }
                            }
                        });

                        if (value.isConvert) {
                            currencyRate = null;
                            debitAmount = numeral(debitAmount).format('0,0.00') + " (" + numeral(debitAmountIdr).format('0,0.00') + ")";
                            creditAmount = numeral(creditAmount).format('0,0.00') + " (" + numeral(creditAmountIdr).format('0,0.00') + ")";
                        }


                    } else if (value.invoice != null) { // Jika ada invoice (debet)

                        if (value.invoice.packaging_list &&
                            value.invoice.packaging_list.container_loading &&
                            value.invoice.packaging_list.container_loading.currency_sgd != null) {
                            currencyRate = value.invoice.packaging_list.container_loading.currency_sgd.currencyrate;
                        }

                    } else if (value.currency_sgd != null) { // Jika tidak ada invoice dan payment (debet)
                        currencyRate = value.currency_sgd.currencyrate;
                        if (value.paymentId) {
                            const receivable = receivableRes.data.find(receiObj =>
                                receiObj.payment && receiObj.payment.id == value.paymentId
                            );
                            if (receivable && receivable.invoice && receivable.invoice.packaging_list.container_loading.currency_sgd) {
                                currencyRate = receivable.payment_allocate[0].invoice_due.receivable.currency_sgd.currencyrate
                            }
                        }
                    }

                    if (currencyRate || !isPrefixSPecial) {
                        debitResult = parent.formatAmount(debitAmount, currencyRate, value.isConvert, isPrefixSPecial);
                        creditResult = parent.formatAmount(creditAmount, currencyRate, value.isConvert, isPrefixSPecial);
                        debitAmount = debitResult.formattedAmount;
                        debitAmountIdr = debitResult.amountIdr;
                        creditAmount = creditResult.formattedAmount;
                        creditAmountIdr = creditResult.amountIdr;
                    }

                    //Faisal 12 Januari : Deposit dari Klaim tidak mempengaruhi perhitungan balance
                    // if (value.type != 'DFM' && ((value.type == 'DEP' && value.claimId != null) || value.isCalculated == 0 || description.includes('Penarikan'))) {


                    if ((value.type == 'DEP' && value.claimId != null && value.type != 'DFM') || (value.type == 'DFM' && value.transactionDate >= '2025-08-25' && value.debitAmount == 0 && value.payment_pending_id == null) || value.isCalculated == 0 || (description.includes('Penarikan') && value.type == 'DEP')) {

                    } else {
                        let subBalance = (debitAmountIdr - creditAmountIdr)
                        countBalance = Math.round(countBalance * 100) / 100 + Math.round(subBalance * 100) / 100;
                    }

                    // if (value.type != 'DFM') {
                    //     let subBalance = (debitAmountIdr - creditAmountIdr)
                    //     countBalance = Math.round(countBalance * 100) / 100 + Math.round(subBalance * 100) / 100;
                    // }

                    let balance = countBalance;
                    if (isPrefixSPecial) {
                        balance = numeral(countBalance).format('0,0.00')
                    } else {
                        balance = numeral(countBalance).format('0,0')
                    }

                    if (value.type == 'DFM') {
                        parent.totalMutasiRemaining = parent.totalMutasiRemaining + (parseFloat(value.creditAmount) - parseFloat(value.payment_sum));
                    }
                    let createdby = "<br/><i>" + value.createdby + "</i>"
                    let receivable = {
                        receivableId: value.id,
                        transactionDate: parent.showDateFormatted(value.transactionDate) + createdby,
                        valueTransactionDate: value.transactionDate,
                        markingHeaderId: value.markingHeaderId,
                        invoicefee: numeral(invoicefee).format('0,0'),
                        isSettled: isSettled,
                        markingheadercode: value.marking_header.markingheadercode,
                        description: description,
                        debitAmount: debitAmount,
                        creditAmount: creditAmount,
                        paymentSum: paymentSum,
                        balance: balance,
                        category: category,
                        type: value.type,
                        claimId: value.claimId,
                        claim: claim,
                        giroId: giroId,
                        giro: giro,
                        payment: value.payment,
                        paymentPendingId: value.payment_pending_id
                    }

                    receivables.push(receivable);
                });
                this.receivables = receivables;
                this.loadingGetReceivable = false;

                parent.depositRemaining = depositRemainingRes.data.remaining
                parent.depositMutasiRemaining = depositMutasiRes.data.remaining

                parent.countBalance = countBalance
                parent.totalKredit = totalKredit
                parent.totalDebet = totalDebet
                parent.totalBalance = totalBalance
            }))
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                });
        },
        getMarkingByCode: _.debounce(
            function (query) {

                if (query !== '') {
                    this.loadingGetMarking = true;
                    HTTP
                        // .post('marking/getByCodeAll', {
                        .post('marking/getBySnapshot', {
                            markingHeaderId: query,
                            subbranchcode: this.subbranchcode
                        })
                        .then(response => {

                            this.invoiceDues = []
                            this.amountResidue = ''
                            this.amountReceived = ''
                            this.description = ''

                            this.loadingGetMarking = false;
                            let data = response.data;

                            const list = data.map(item => {
                                return {
                                    value: item.markingheaderid,
                                    label: item.markingheadercode,
                                    top_color: item.top_color
                                };
                            });

                            this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                        })
                        .catch(e => {
                            this.loadingGetMarking = false;
                            this.$Notice.error({
                                title: "Error",
                                desc: e,
                                duration: 5
                            });
                        })
                } else {
                    this.optionMarkings = [];

                }
            }, 400
        ),
        showDateFormatted: function (stringToFormat) {
            let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
            return moment(dateToFormat).format("DD MMM YYYY")
        },
        isSettled: function (invoice) {
            if (invoice != null) {
                if (invoice.settledDate != null) {
                    return true;
                }
            }

            return false;
        },
        handleKreditClick: function (row) {

            this.modal.createPayment = true

            this.createPaymentPending.paymentDate = moment(Date.now()).locale('id').format('yyyy-MM-DD');
            this.createPaymentPending.description = '';
            this.createPaymentPending.mutasiRemainingPayment = this.totalMutasiRemaining;
            this.createPaymentPending.paymentPendingId = row.paymentPendingId;
            this.createPaymentPending.category = "pay";
            this.createPaymentPending.receivableId = row.receivableId;

            this.invoiceDues = [];
            this.getInvoiceData()
        },
        getInvoiceDueUnSettled: function () {
            if (this.markingIdSelected !== '') {
                return HTTP.get('invoiceDue/unsettled/' + this.markingIdSelected)
            } else {
                this.invoiceDues = []
            }
        },
        getInvoiceData: function () {
            this.loadingGetPayment = true;

            this.invoiceDues = []
            this.createPaymentPending.amountResidue = ''
            this.createPaymentPending.amountReceived = ''
            this.createPaymentPending.description = ''
            this.createPaymentPending.totalUseDepositAmount = 0;

            if (this.markingIdSelected == '') {
                this.loadingGetPayment = false;
                return;
            }

            let parent = this;

            axios.all([
                this.getInvoiceDueUnSettled(),
            ]).then(axios.spread((unSettledRes) => {
                let invoiceDuesFormatted = []
                _.forEach(unSettledRes.data, function (value) {

                    let receivableType = value.receivable.type;

                    let invoicefee = value.receivable.debitAmount;
                    let invoicedate = value.receivable.transactionDate;
                    let invoicedatedue = '';

                    if (receivableType != 'MAN') {
                        let invoicefee = value.receivable.invoice.invoicefee;
                        let invoicedatedue = value.receivable.invoice.invoicedatedue;
                        let invoicedate = value.receivable.invoice.invoicedate;
                    }

                    let paymentSum = value.paymentSum;
                    let receivableRemaining = invoicefee - paymentSum;
                    let receivableDebitAmount = value.receivable.debitAmount;

                    let payment = {
                        id: value.id,
                        receivableId: value.receivableId,
                        invoicefee: invoicefee, // total invoice
                        paymentSum: paymentSum, // total pembayaran yang sudah dilakukan
                        receivableRemaining: receivableRemaining, // sisa piutang
                        description: value.receivable.description,
                        invoicedate: invoicedate, //numeral(value.receivable.creditAmount).format('0,0')
                        invoicedatedue: invoicedatedue,
                        receivableDebitAmount: receivableDebitAmount, // menyimpan nilai awal
                        allocateAmount: 0,
                        deviationAmount: 0, // untuk menyimpan kelebihan bayar
                        useDepositAmount: 0, // nilai penggunaan deposit (jika ada deposit)
                        markingHeaderId: value.receivable.markingHeaderId,
                        pendingAmount: 0,
                        discountAmount: 0
                    }

                    invoiceDuesFormatted.push(payment);
                });

                if (invoiceDuesFormatted.length > 0) {
                    invoiceDuesFormatted = _.sortBy(invoiceDuesFormatted, ['invoicedate'], function (value) { return new Date(value); });

                    let pendingAmount = this.createPaymentPending.paymentPendingAmount;
                    let index = 0;

                    if (pendingAmount && pendingAmount > 0) {
                        _.forEach(invoiceDuesFormatted, function (value) {
                            if (pendingAmount && pendingAmount > 0 && pendingAmount > value.receivableRemaining) {
                                invoiceDuesFormatted[index].pendingAmount = value.receivableRemaining;
                                pendingAmount = pendingAmount - value.receivableRemaining;
                            } else if (pendingAmount && pendingAmount > 0 && pendingAmount <= value.receivableRemaining) {
                                invoiceDuesFormatted[index].pendingAmount = pendingAmount;
                                pendingAmount = 0;
                            }

                            index++;
                        });
                    }

                    parent.invoiceDues = invoiceDuesFormatted;
                } else {
                    if (this.markingIdSelected) {
                        this.$Message.info('Piutang tidak ditemukan');
                    }
                }
                parent.loadingGetPayment = false;
            }))
                .catch(e => {
                    console.log(e)
                    this.loadingGetPayment = false;
                    this.$Notice.error({
                        title: "Error",
                        desc: 'Silahkan Cek Menu Piutang > Hapus Piutang',
                        duration: 0
                    });
                });
        },
        setAllocateAmount: function (invoiceDue) {
            const isDeviation = invoiceDue.allocateAmount + invoiceDue.useDepositAmount > invoiceDue.receivableRemaining
            if (isDeviation) {
                invoiceDue.deviationAmount = (invoiceDue.allocateAmount + invoiceDue.useDepositAmount) - invoiceDue.receivableRemaining;
            } else {
                invoiceDue.deviationAmount = 0
            }

            var index = _.findIndex(this.invoiceDues, { id: invoiceDue.id });

            // Replace item at index using native splice
            this.invoiceDues.splice(index, 1, invoiceDue);

            // var invoiceDueChanged = _.find(this.invoiceDues, {id: invoiceDue.id});
            this.setResidueAmount(true);
            this.checkButtonSave();
        },
        setMarkingCode: function () {
            // this.markingIdSelected = ''

            const selectedOption = this.optionMarkings.find(
              item => item.value === this.markingIdSelected
            );

            if (selectedOption) {
              this.markingLabelSelected = selectedOption.label;
              this.topColor = selectedOption.top_color;
            } else {
              this.markingLabelSelected = "";
              this.topColor = "";
            }

            this.getReceivableData()
            this.createPaymentPending.selectedMarkingLabel = this.optionMarkings.find(item => item.value == this.markingIdSelected).label
        },
        setResidueAmount: function (fromChild) {
            let allocateAmounts = _.sumBy(this.invoiceDues, 'allocateAmount');
            let allocateDiscountAmounts = _.sumBy(this.invoiceDues, 'discountAmount');
            this.createPaymentPending.amountResidue = this.createPaymentPending.amountReceived - allocateAmounts;

            if (fromChild) {
                this.createPaymentPending.amountReceived = allocateAmounts;
                this.createPaymentPending.totalUseDepositAmount = _.sumBy(this.invoiceDues, 'useDepositAmount');

                this.createPaymentPending.discountReceived = allocateDiscountAmounts;
            }

            let sumDeviation = _.sumBy(this.invoiceDues, 'deviationAmount');
            this.createPaymentPending.depositAmount = sumDeviation
        },
        postPayment: function () {

            if (this.createPaymentPending.depositAmount > 0 && this.createPaymentPending.depositType == '') {
                this.modal.createPayment = true;
                return;
            } else {
                this.modal.createPayment = false;
            }

            this.loadingPost = true
            let paymentAllocates = [];

            _.forEach(this.invoiceDues, function (invoiceDue) {
                if (invoiceDue.allocateAmount + invoiceDue.useDepositAmount != 0 ||
                    invoiceDue.invoicefee == 0) {
                    let paymentAllocate = {
                        invoicefee: invoiceDue.invoicefee, // total invoice awal
                        invoiceDueId: invoiceDue.id,
                        allocateAmount: invoiceDue.allocateAmount, // allocate amount yang dibayar
                        receivableRemaining: invoiceDue.receivableRemaining, // sisa piutang yang bisa dibayar
                        useDepositAmount: invoiceDue.useDepositAmount,
                        description: invoiceDue.description,
                    }
                    paymentAllocates.push(paymentAllocate);
                }

            });

            this.createPaymentPending.paymentAllocates = paymentAllocates;
            let transactionDate = moment(this.createPaymentPending.paymentDate, "DD/MM/YYYY").format('YYYY/MM/DD')

            let payload = {
                receivableId: this.createPaymentPending.receivableId,
                markingHeaderId: this.markingIdSelected,
                amount: this.createPaymentPending.amountReceived,
                transactionDate: transactionDate,
                description: this.createPaymentPending.description,
                accountNumber: this.createPaymentPending.accountNumber,
                depositAmount: this.createPaymentPending.depositAmount,
                paymentAllocates: this.createPaymentPending.paymentAllocates,
                depositType: this.createPaymentPending.depositType,
                category: this.createPaymentPending.category,
                paymentPendingId: this.createPaymentPending.paymentPendingId,
                creditRound: this.createPaymentPending.creditRound,
                coaId: this.createPaymentPending.creditRound > 0 ? this.createPaymentPending.coaId : null
            }

            // console.log({ payload });
            // return false

            HTTP
                .post('payment/payPending', payload)
                .then(response => {
                    this.loadingPost = false

                    this.$Message.success({
                        content: 'Pembayaran Berhasil',
                        duration: 5
                    });

                    this.getReceivableData()
                })
                .catch(e => {
                    this.loadingPost = false
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        checkButtonSave: function () {
            let paymentDate = this.createPaymentPending.paymentDate
            let description = this.createPaymentPending.description
            let amountReceived = this.createPaymentPending.amountReceived
            let mutasiRemainingPayment = this.createPaymentPending.mutasiRemainingPayment

            this.isButtonSave = false
            if (paymentDate && description && amountReceived > 0 && amountReceived <= mutasiRemainingPayment) {
                this.isButtonSave = true
            } else {
                this.isButtonSave = false
            }

            this.invoiceDues.map((invoiceDue) => {
                if (invoiceDue.deviationAmount > 0) {
                    this.isButtonSave = false
                }
            })
        },
        formatAmount: function (amount, currencyRate, isConvert, isPrefixSpecial) {
            let amountIdr = amount;
            let formattedAmount = "";

            if (currencyRate != null && isConvert) {
                amountIdr = amount * currencyRate;
                formattedAmount = numeral(amount).format('0,0.00') + " (" + numeral(amountIdr).format('0,0.00') + ")";
            } else if (isPrefixSpecial) {
                formattedAmount = numeral(amount).format('0,0.00');
            } else {
                formattedAmount = numeral(amount).format('0,0');
            }

            return {
                formattedAmount,
                amountIdr
            };
        },
    },
    filters: {
        currency: function (value) {
            if (!value) return ''
            return numeral(value).format('0,0')
        }
    },
    watch: {
        "createPaymentPending.amountReceived": function (newAmountReceived) {
            this.setResidueAmount(false)
        }
    },
    created() {
        //this.getReceivable();
        this.user.username = localStorage.getItem('user.username')
        this.user.role = localStorage.getItem('user.role')
    }
}

</script>



// WEBPACK FOOTER //
// ReceivableList.vue?2cb70ac8